module.exports = __webpack_public_path__ + "img/13.56ca1481.png";